/* global VXConfig */
import React     from 'react';
import Flux      from '../../../flux/Flux';
import PropTypes from 'prop-types';

function isEmpty(obj) {
	for (const prop in obj) {
		if (obj.hasOwnProperty(prop)) {
			return false;
		}
	}
	return true;
}

function withCompetitions(WrappedComponent) {
	class Competitions extends React.Component {

		constructor(props) {
			super(props);
			const stored    = this.props.contestData ? this.props.contestData : Flux.Contest.getVxqlContestsFromStore(); // special for lindemann, no vxql request
			this.state      = {
				contests: isEmpty(stored) ? null : stored,
			};
			this.onContests = this.onContests.bind(this);
		}

		componentDidMount() {
			if (!this.props.contestData && isEmpty(Flux.Contest.getVxqlContestsFromStore())) {
				Flux.Contest.getVxqlContestsFromApi(!VXConfig.isVXMobilePlatform, this.onContests);
			}
		}

		onContests() {
			this.setState({
				contests: Flux.Contest.getVxqlContestsFromStore(),
			});
		}

		render() {
			return <WrappedComponent contests={this.state.contests} {...this.props} />;
		}
	}

	Competitions.propTypes = {
		contestData: PropTypes.object,
	};

	return Competitions;
}

export default withCompetitions;
